import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import { Button } from "../components/ui/button";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen bg-cream flex items-center justify-center px-4" data-testid="payment-cancel-page">
      <div className="max-w-md w-full bg-white rounded-3xl border border-[#EFE9E0] p-8 sm:p-10 text-center shadow-[0_30px_70px_-50px_rgba(45,40,37,0.5)]">
        <XCircle size={56} className="mx-auto text-terracotta" />
        <h1 className="mt-4 font-serif text-3xl text-ink">Payment cancelled</h1>
        <p className="mt-3 text-[#524B46]">
          No worries — your cake request is still saved. You can reserve your date with a deposit whenever you're ready.
        </p>
        <Link to="/#custom-order">
          <Button
            data-testid="payment-cancel-retry"
            className="mt-8 w-full h-12 rounded-full bg-olive hover:bg-olive-hover text-cream"
          >
            Back to Custom Order
          </Button>
        </Link>
      </div>
    </div>
  );
}
